module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "title": "Modifier le mot de passe"
    },
    on: {
      "close": function($event) {
        _vm.cancel()
      }
    }
  }, [_c('div', {
    staticClass: "password-change"
  }, [(_vm.message !== null) ? _c('div', {
    class: 'callout callout-' + _vm.message.type
  }, [_c('p', [_vm._v(_vm._s(_vm.message.text))])]) : _vm._e(), _vm._v(" "), _c('div', [_c('label', [_vm._v("Nouveau mot de passe")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "length": "4"
    },
    domProps: {
      "value": (_vm.newPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "error-message"
  }, [_vm._v("\n        " + _vm._s(this.passwordValidationMessage) + "\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "security"
  }, [_vm._v("\n      Pour des mesures de sécurité, nous vous demandons de resaisir votre nom d'utilisateur et mot de passe. Merci\n      pour votre compréhension\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', [_vm._v("Votre login")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.challengedUsername),
      expression: "challengedUsername"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.challengedUsername)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.challengedUsername = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', [_vm._v("Votre mot de passe")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.challengedPassword),
      expression: "challengedPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "length": "4"
    },
    domProps: {
      "value": (_vm.challengedPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.challengedPassword = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [(!_vm.canOnlyExitModal) ? _c('div', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.cancel()
      }
    }
  }, [_vm._v("Annuler")]) : _vm._e(), _vm._v(" "), (!_vm.canOnlyExitModal) ? _c('div', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.ok()
      }
    }
  }, [_vm._v("Modifier")]) : _vm._e()]), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "loading-overlay"
  }, [_vm._v("\n      Chargement ...\n    ")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-12a7696a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/ChangePasswordModal.vue
// module id = 1805
// module chunks = 2